// Recruitment check on the MADAPI /get-user row. Cameroon rule: a visitor who is ACTIVE, or PENDING
// (subscribe accepted by MTN, Comviva activation callback still to come), is sent to the portal;
// everyone else (GRACE, SUSPENDED, CANCELLED, EXPIRED, unknown) goes through the subscribe flow.
// Status is dbo.cfg_Status.InternalStatusName in upper case; compared lowercased, startsWith, because
// unmapped legacy rows come through as e.g. 'Active Subscription'.
const PORTAL_STATUSES = ['active', 'pending']

export function readSubscriptionStatus(user) {
  if (!user) return ''
  return String(user.Status ?? user.status ?? '')
    .trim()
    .toLowerCase()
}

export function isSubscribed(user) {
  const status = readSubscriptionStatus(user)
  return PORTAL_STATUSES.some((allowed) => status.startsWith(allowed))
}

export default { isSubscribed, readSubscriptionStatus }
